import FormField from 'components/FormField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';
import { Input } from 'antd';
import useCrud from 'hooks/useCrud';
import { taskList } from 'services/api/remind';
import { useMount } from 'ahooks';
import { useFormikContext } from 'formik';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

const nameLimitLength = 30;

function TaskName() {
  const { t } = useTranslate();

  const { whiteListConfig: { AIDE_REMOVE_TASK } = {} } = useOrgConfigStateValue();

  const {
    values: { taskId },
  } = useFormikContext<FV>();

  const { list, fetchList } = useCrud({
    readList: () => taskList().then((res) => res.configs),
  });

  useMount(() => {
    fetchList().catch(() => {});
  });

  return (
    <FormField<FV['taskName']>
      required
      name="taskName"
      label={AIDE_REMOVE_TASK ? t('marketing.策略名称') : t('marketing.任务名称')}
      validate={(value) => {
        if (!value || !value.trim()) {
          return AIDE_REMOVE_TASK ? t('marketing.请输入策略名称') : t('marketing.请输入任务名称');
        }

        if (list?.some((_) => _.taskName === value && _.taskId !== taskId)) {
          return AIDE_REMOVE_TASK ? t('marketing.策略名称已存在') : t('marketing.任务名称已存在');
        }
      }}
    >
      {({ field }) => {
        return (
          <Input
            placeholder={
              AIDE_REMOVE_TASK ? t('marketing.请输入策略名称') : t('marketing.请输入任务名称')
            }
            showCount
            maxLength={nameLimitLength}
            {...field}
            style={{ width: '570px' }}
          />
        );
      }}
    </FormField>
  );
}

export default TaskName;
